import React from 'react';
import {Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {setTitle} from './util';
import fetch from './fetch';
import moment from 'moment';

class BrushProviders extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            brushlinks_paired: false,
            brushlink_reg_token: "",
            preferences: {
                brushlink_accepted: null,
                sonicare_accepted: null,
            },
            grushPairModalState: false,
            grushSignupModalState: false,
            grush_pair_username: "",
            grush_pair_password: "",

            terms_accepted: null,
            grush_signup_username: "",
            grush_signup_password: "",
            grush_signup_account: "",
            grush_signup_email: "",
            grush_signup_practice: "",
            grush_signup_study_group: "",

            accept_checked: false,


        }

        this.toggleGrushPairModal = this.toggleGrushPairModal.bind(this);
        this.toggleGrushSignupModal = this.toggleGrushSignupModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleGrushPairSubmit = this.handleGrushPairSubmit.bind(this);
    }

    static brushlinkPair() {
        const state = Math.random().toString();
        window.sessionStorage.setItem('brush_brushlink_state', state);
        const nonce = Math.random().toString();
        window.sessionStorage.setItem('brush_brushlink_nonce', nonce);

        const url = `https://admin-us.brushlink.com/oauth/authorize?` +
            `response_type=${encodeURIComponent('code')}&` +
            `client_id=378daedf0c27c77bba2fe3de5619d833b92a3acd8765bdb7ffee3e9aca3ae4bf&` +
            `redirect_uri=${encodeURIComponent('https://smartbrush.ddx.dental/brushlink-offline-callback')}&` +
            `state=${encodeURIComponent(state)}&` +
            `nonce=${encodeURIComponent(nonce)}`;
        window.sessionStorage.setItem('brush_brushlink_authorize_url', url);

        window.open(`${url}&prompt=none`, "_blank");
        //window.location = `${url}&prompt=none`;
    }

    componentWillMount() {
    }

    componentDidMount() {
        setTitle('Brush Providers');
        fetch('/api/v1/brush-status', {
            method: 'GET',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    return;
                }
                let body = await resp.json();
                this.setState({
                    brushlink_paired: body.brushlink,
                    grush_paired: body.grush
                });
            })
            .catch((err) => {
                console.error('Could not get brush pairing status', err);
            });

        fetch('/api/v1/brushlink-reg-token', {
            method: 'GET',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    return;
                }
                let body = await resp.json();
                if (!body.hasOwnProperty('one_time_token')) {
                    return;
                }

                fetch('/api/v1/provider-info', {
                    method: 'GET',
                })
                    .then(async (resp) => {
                        if (!resp || !resp.ok) {
                            return;
                        }
                        let body = await resp.json();
                        this.userInfo = body;
                    })
                    .catch((err) => {
                        console.error('Could not get DDX user info', err);
                    });
                this.setState({
                    brushlink_reg_token: body.one_time_token
                });
            })
            .catch((err) => {
                console.error('Could not get brushlink registration token', err);
            });

        fetch('/api/v1/preferences', {
            method: 'GET',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();

                let acceptedTime = null;
                if (body && body.hasOwnProperty('terms_accepted')) {
                    acceptedTime = moment(body.terms_accepted);
                    if (!acceptedTime.isValid() || acceptedTime.isBefore(moment("2020-09-15", "YYYY-MM-DD"))) {
                        acceptedTime = null;
                    }
                }
                this.setState({
                    preferences: body,
                    terms_accepted: acceptedTime,
                });
            })
            .catch((err) => {
                console.error('Could not fetch preferences', err);
            });


    }

    grushPair() {
        this.toggleGrushPairModal();
        /*const state = Math.random().toString();
        window.sessionStorage.setItem('brush_grush_state', state);
        const nonce = Math.random().toString();
        window.sessionStorage.setItem('brush_grush_nonce', nonce);

        const url = `https:/13.57.57.202:8081/oauth/`;
        window.sessionStorage.setItem('brush_grush_authorize_url', url);
        window.open(`${url}&prompt=none`, "_blank");*/
    }

    brushlinkSignup() {
        let practiceName = this.userInfo && this.userInfo.hasOwnProperty('ddx_parent_name') ? this.userInfo.ddx_parent_name : '';
        let givenName = this.userInfo && this.userInfo.hasOwnProperty('given_name') ? this.userInfo.given_name : '';
        let familyName = this.userInfo && this.userInfo.hasOwnProperty('family_name') ? this.userInfo.family_name : '';
        let email = this.userInfo && this.userInfo.hasOwnProperty('email') ? this.userInfo.email : '';
        let phoneNumber = this.userInfo && this.userInfo.hasOwnProperty('phone_number') ? this.userInfo.phone_number : '';

        const url = `https://admin-us.brushlink.com/support/registration?one_time_token=${encodeURIComponent(this.state.brushlink_reg_token)}` +
            `&practice_name=${encodeURIComponent(practiceName)}` +
            `&first_name=${encodeURIComponent(givenName)}` +
            `&last_name=${encodeURIComponent(familyName)}` +
            `&email=${encodeURIComponent(email)}` +
            `&phone_number=${encodeURIComponent(phoneNumber)}`;
        window.open(url, "_blank");
    }

    grushSignup() {
        this.toggleGrushSignupModal();
        //const url = `https://smartbrush.ddx.dental/...`;
    }

    brushlinkDisconnect() {
        fetch('/api/v1/brushlink-disconnect', {
            method: 'POST',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    return;
                }
                window.location.reload();
            })
            .catch((err) => {
                console.error('Could not get disconnect brushlink', err);
            });
    }

    grushDisconnect() {
        fetch('/api/v1/grush-disconnect', {
            method: 'POST',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    return;
                }
                window.location.reload();
            })
            .catch((err) => {
                console.error('Could not get disconnect brushlink', err);
            });
    }

    toggleGrushPairModal() {
        this.setState(prevState => ({
            grushPairModalState: !prevState.grushPairModalState,
        }));
    }

    toggleGrushSignupModal() {
        this.setState(prevState => ({
            grushSignupModalState: !prevState.grushSignupModalState,
        }));
    }

    handleGrushSignupSubmit(e) {
        e.preventDefault();

        let grushUsername = this.state.grush_signup_username;
        let grushEmail = this.state.grush_signup_email;
        let grushPassword = this.state.grush_signup_password;
        let grushAccount = this.state.grush_signup_account;
        let grushPractice = this.state.grush_signup_practice;
        let grushStudyGroup = this.state.grush_signup_study_group;

        fetch('/api/v1/grush-signup-practice', {
            method: 'POST',
            body: JSON.stringify({
                grush_username: grushUsername,
                grush_email: grushEmail,
                grush_password: grushPassword,
                grush_account: grushAccount,
                grush_practice: grushPractice,
                grush_study_group: grushStudyGroup,
            }),
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    alert("Could not register your Grush Account. Please double-check your input.");
                    return;
                }
                this.setState({
                    grush_pair_username: grushUsername,
                    grush_pair_password: grushPassword,
                });
                console.log("Registered, pairing...");
                this.grushSignup();
                //window.location.reload();
            })
            .catch((err) => {
                console.error('Could not get signup grush account: ', err);
            });

    }

    handleGrushPairSubmit(e) {
        e.preventDefault();
        let grushUsername = this.state.grush_pair_username;
        let grushPassword = this.state.grush_pair_password;


        fetch('/api/v1/grush-pair-practice', {
            method: 'POST',
            body: JSON.stringify({
                grush_account: grushUsername,
                grush_password: grushPassword,
            }),
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    alert("Could not pair Grush Account to DDX Practice");
                    return;
                }
                window.location.reload();
            })
            .catch((err) => {
                console.error('Could not get disconnect brushlink', err);
            });
    }

    handleChange(e) {
        this.setState({[e.target.name]: e.target.value});
    }

    termsAccepted() {
        this.setState({
            terms_accepted: true
        });
        fetch('/api/v1/accept-terms', {
            method: 'POST',
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    console.log('could not save acceptance of terms.');
                    return;
                }
            })
            .catch((err) => {
                console.error('could not save acceptance of terms: ', err);
            });

    }

    toggleAccepted() {
        this.setState({
            accept_checked: !this.state.accept_checked,
        });
    }

    render() {
        if (!this.state.terms_accepted) {
            return (
                <div>
                    <h3>Before you can use the DDX SmartBrush, you must agree to our terms of service. Please review the
                        information below and accept the terms to continue.</h3>
                    <a href="/Service-Agreement.docx">Service Agreement Document</a>
                    <br/>
                    <input type="checkbox" onClick={this.toggleAccepted.bind(this)}/>
                    <p>
                        By checking this box, you agree to the terms in the document linked above
                    </p>
                    <Button className="ml-2" color="info" disabled={!this.state.accept_checked}
                            onClick={this.termsAccepted.bind(this)}>Accept</Button>
                </div>
            );
        }

        let grush_paired = null;
        if (this.state.grush_paired === true) {
            grush_paired = (
                <span>
                    <Button color="success" disabled>Paired</Button>
                    <Button className="ml-2" color="danger"
                            onClick={this.grushDisconnect.bind(this)}>Disconnect</Button>
                </span>
            );
        } else {
            let grushTermsAccepted = this.state.preferences.grush_accepted;
            if (grushTermsAccepted == null) {

            }

            let grushSignUp = null;
            if (!this.state.grush_reg_token) {
                grushSignUp = (
                    <span>
                        <Button color="info" className="ml-5"
                                onClick={this.toggleGrushSignupModal}>Sign up with Grush</Button>
                        <Modal isOpen={this.state.grushSignupModalState}>
                            <ModalHeader toggle={this.toggleGrushSignupModal}>Grush Signup</ModalHeader>
                            <Form onSubmit={(e) => this.handleGrushSignupSubmit(e)}>
                                <ModalBody>
                                    <FormGroup className="d-flex flex-column p-2">
                                        <span className="d-flex flex-row p-1">
                                            <Label className="content-label pr-1">Dentist Name</Label>
                                            <Input
                                                type="text"
                                                name="grush_signup_username"
                                                className="text-left"
                                                onChange={this.handleChange}
                                                value={this.state.grush_signup_username}
                                                required
                                            />
                                        </span>
                                        <span className="d-flex flex-row p-1">
                                            <Label className="content-label pr-1">Email</Label>
                                            <Input
                                                type="text"
                                                name="grush_signup_email"
                                                className="text-left"
                                                onChange={this.handleChange}
                                                value={this.state.grush_signup_email}
                                                required
                                            />
                                        </span>
                                       <span className="d-flex flex-row p-1">
                                            <Label className="content-label pr-1">Account (phone number)</Label>
                                            <Input
                                                type="text"
                                                name="grush_signup_account"
                                                className="text-left"
                                                onChange={this.handleChange}
                                                value={this.state.grush_signup_account}
                                                required
                                            />
                                        </span>
                                        <span className="d-flex flex-row p-1">
                                            <Label className="content-label pr-1">Password</Label>
                                            <Input
                                                type="password"
                                                name="grush_signup_password"
                                                className="text-left"
                                                onChange={this.handleChange}
                                                value={this.state.grush_signup_password}
                                                required
                                            />
                                        </span>
                                        <span className="d-flex flex-row p-1">
                                            <Label className="content-label pr-1" hidden>Practice Name</Label>
                                            <Input
                                                type="text"
                                                name="grush_signup_practice"
                                                className="text-left"
                                                onChange={this.handleChange}
                                                value={this.state.grush_signup_practice}
                                                hidden
                                            />
                                        </span>
                                        <span className="d-flex flex-row p-1">
                                            <Label className="content-label pr-1" hidden>Study Group</Label>
                                            <Input
                                                type="text"
                                                name="grush_signup_study_group"
                                                className="text-left"
                                                onChange={this.handleChange}
                                                value={this.state.grush_signup_study_group}
                                                hidden
                                            />
                                        </span>
                                    </FormGroup>
                                </ModalBody>
                                <ModalFooter>
                                    <Button type="submit" color="info" onClick={(e) => this.handleGrushSignupSubmit(e)}>Pair Grush Account</Button>
                                    <Button color="secondary"
                                            onClick={(e) => this.toggleGrushSignupModal()}>Cancel</Button>
                                </ModalFooter>
                            </Form>
                        </Modal>
                    </span>
                );
            }
            grush_paired = (
                <span>
                    <Button color="warning" onClick={this.toggleGrushPairModal}>Pair existing Grush account</Button>
                    {grushSignUp}
                    <Modal isOpen={this.state.grushPairModalState}>
                        <ModalHeader toggle={this.toggleGrushPairModal}>Grush Pair</ModalHeader>
                        <Form onSubmit={(e) => this.handleGrushPairSubmit(e, this.state.grushPairDetails.account)}>
                            <ModalBody>
                                <FormGroup className="d-flex flex-column p-2">
                                    <span className="d-flex flex-row p-1">
                                        <Label className="content-label pr-1">Username (Phone Number)</Label>
                                        <Input
                                            type="text"
                                            name="grush_pair_username"
                                            className="text-left"
                                            onChange={this.handleChange}
                                            value={this.state.grush_pair_username}
                                            required
                                        />
                                    </span>
                                    <span className="d-flex flex-row p-1">
                                        <Label className="content-label pr-1">Password</Label>
                                        <Input
                                            type="password"
                                            name="grush_pair_password"
                                            className="text-left"
                                            onChange={this.handleChange}
                                            value={this.state.grush_pair_password}
                                            required
                                        />
                                    </span>
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter>
                                <Button type="submit" color="info" onClick={(e) => this.handleGrushPairSubmit(e)}>Pair Grush Account</Button>
                                <Button color="secondary" onClick={(e) => this.toggleGrushPairModal()}>Cancel</Button>
                            </ModalFooter>
                        </Form>
                    </Modal>

                </span>
            );
        }

        let brushlink_paired = null;
        if (this.state.brushlink_paired === true) {
            brushlink_paired = (
                <span>
                    <Button color="success" disabled>Paired</Button>
                    <Button className="ml-2" color="danger"
                            onClick={this.brushlinkDisconnect.bind(this)}>Disconnect</Button>
                </span>
            );
        } else {

            let blTermsAccepted = this.state.preferences.brushlink_accepted;
            if (blTermsAccepted == null) { // document link & accept button
                //blTermsAccepted = (

                //);
            }
            let signUp = null;
            if (this.state.brushlink_reg_token) {
                signUp = (
                    <Button color="info" className="ml-5" onClick={this.brushlinkSignup.bind(this)}>Sign up with
                        Brushlink</Button>
                );
            }
            brushlink_paired = (
                <span>
                    <Button color="warning"
                            onClick={BrushProviders.brushlinkPair}>Pair existing Brushlink account</Button>
                    {signUp}
                </span>
            );
        }

        let bl = null;
        if (process.env.REACT_APP_BRUSHLINK_ENABLED === "1") {
            bl = (
                <FormGroup>
                    Brushlink
                    <Col sm={9}>
                        {brushlink_paired}
                    </Col>
                </FormGroup>
            );
        }

        let gr = null;
        if (process.env.REACT_APP_GRUSH_ENABLED === "1") {
            gr = (
                <FormGroup>
                    Grush
                    <Col sm={8}>
                        {grush_paired}
                    </Col>
                </FormGroup>
            )
        }

        let oralb = null;
        if (process.env.REACT_APP_ORALB_ENABLED === "1") {
            oralb = (
                <FormGroup>
                    Oral-B
                    <Col sm={8}>
                     <span>
                        <Button color="success" href="https://smartbrush.ddx.dental/oralb"
                                tag="a">Pair a patient with Oral-B</Button>
                     </span>
                    </Col>
                </FormGroup>
            )
        }

        return (
            <div>
                <h2 id="title">Brush Providers</h2>
                <p>
                    Pair with brush providers to support patients with those smart toothbrushes, and to view and
                    interact with their brushing data.
                </p>
                <Form>
                    {bl}
                    {gr}
                    {oralb}
                </Form>
            </div>
        );
    }
}

export default BrushProviders;